import '@fontsource/roboto'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import App from '@/App'
import store from '@/store'
import router from '@/router'

Vue.use(Vuetify, {
  iconfont: 'md'
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
  created () {
    this.$store.dispatch('init')
  }
})



// WEBPACK FOOTER //
// ./src/main.js